<div class="container-fluid">
<div class="row">
</div>
  <div class="row col-md-12 d-flex align-items-center">
    <div class="col-md-6 p-0">
      <div class="mat-title titleColor font-weight-bold">Create New <span *ngIf="userType == 'Beneficiary'">Beneficiary</span>
        <span *ngIf="userType == 'I9Admin'">Employee</span></div>
      <div class="mat-subheading-1 titleColor">Search or create new <span *ngIf="userType == 'Beneficiary'">beneficiaries</span>
        <span *ngIf="userType == 'I9Admin'">employees</span></div>
    </div>
    <div class="col-md-6 p-0 mb-3">
        <div class="_action">
            <button mat-flat-button color="default" (click)="openFormModalCreate()"  class="text-uppercase _btn mat-flat-button mat-button-base mat-default"><mat-icon class="_add">add</mat-icon>CREATE NEW</button>
        </div>  
    </div>
  </div>
  <div class="bgWhite noMargin w100 bxShadow mHeight">
    <div class="row position-relative">
      <div class="col-md-5 mt-5">
        <span class="p-input-icon-right searchInput">
          <i class="pi pi-search" (click)="searchInput()"></i>
          <input type="text" pInputText [(ngModel)]="searchBeneficiary" [placeholder]="userType == 'I9Admin' ? 'Search Employees': 'Search Beneficiaries'"
            (keyup)="showNoContent=null" (keyup.enter)="searchInput()" class="bradius">
        </span>
        <small class="d-block searchInput"
          [style.visibility]="(!this.searchBeneficiary || (this.searchBeneficiary && this.searchBeneficiary.length < 3)) ? 'visible' : 'hidden'">Type
          at least 3 characters</small>
      </div>
      <div class="col-md-1 mt-5">
        <span class="dividerInput">|</span>
      </div>
      <div class="col-md-6 mt-5">
        <span class="inviteTxt pr-3">
          Invite a <b *ngIf="userType == 'Beneficiary'">Beneficiary</b> <b *ngIf="userType == 'I9Admin'">Employee</b> you already know?
        </span>
        <button type="button" (click)="sendInvite()"
          class="im-btn button_whitebg im-btn-with-icon im-btn-outline-primary">
          <i class="fa fa-chevron-right im-drop-icon"></i>&nbsp; Send Invite
        </button>
        <!-- <div class="d-block">
          <small><b>Note:</b> You have an option to share Help Video of 'Part 2 - Beneficiary accepting invite from Petitioner' to beneficiary on Facebook, X (Twitter), Tumblr or Email.</small>
        </div> -->
      </div>
      <div class="help-video-section">
        <app-help-video-overlay #helpVideoOverlayComponent></app-help-video-overlay>
      </div>
    </div>
    <div class="row" *ngIf="searchResult">
      <div class="col-sm-12 pt-5">
        <ng-container *ngIf="showNoContent != null && showNoContent === true && searchBeneficiary.length >= 3">
          <p class="p-3 ml-5">
            Your search <b>'{{searchBeneficiary}}'</b> did not match any Platform 
            <span  *ngIf="userType == 'Beneficiary'">Beneficiary</span>
            <span  *ngIf="userType == 'I9Admin'">Employee</span> <br />
            Make sure you spelled the name correctly
          </p>
        </ng-container>
        <ng-container *ngIf="showNoContent != null && showNoContent === false && searchBeneficiary.length >= 3">
          <p-table [responsive]="true" [value]="beneficiaryDetails" tableStyleClass="attorney-search-beneficiary">
            <ng-template pTemplate="header">
              <tr>
                <th  *ngIf="userType == 'Beneficiary'">Beneficiary Name</th>
                <th  *ngIf="userType == 'I9Admin'">Employee Name</th>
                <th>Date of Birth</th>
                <th>Contact No.</th>
                <th>Actions</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-beneficiaryDetails>
              <tr>
                <td>{{beneficiaryDetails.fname}} {{beneficiaryDetails.lname}}</td>
                <td>{{beneficiaryDetails.dob | date }}</td>
                <td>{{beneficiaryDetails.contactNo}}</td>
                <td (click)="sendInvite()">
                  <mat-icon matTooltip="Click to invite beneficiary">link</mat-icon>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <p-paginator styleClass="float-right" [rows]="pageSize" [totalRecords]="totalRecords" pageLinkSize="5"
            [rowsPerPageOptions]="[25,50,100]" [alwaysShow]="true" (onPageChange)="paginate($event)" #paginator>
          </p-paginator>
        </ng-container>
      </div>
    </div>
  </div>
</div>

